export default {

    //empty-states
    no_coupons: 'Ups! Keine Gutscheine',
    text_coupon: 'Beginnen Sie mit der Erstellung eines neuen Rabattcoupons.',
    new_coupon: 'Neuer Coupon',

}